// extracted by mini-css-extract-plugin
export default {"content-container":"Home_content-container__PN2Mi","content-header":"Home_content-header__6V7Th","content-body":"Home_content-body__2LfLs","content-item":"Home_content-item__M7Q7g"};